import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { jobHistorySearchSchema } from '@/ui/pages/Installer/JobHistory/jobHistoryModel';
import JobHistoryPage from '@/ui/pages/Installer/JobHistory/JobHistoryPage';

/**
 * HS-1641: the installer's closed jobs. As `installations.index.tsx`, the definition loads inside
 * the loader so the screen and the mock transport stay out of the entry chunk.
 */
export const Route = createFileRoute('/_dashboard/installer/jobs/')({
  validateSearch: (input: Record<string, unknown>) => jobHistorySearchSchema.parse(input),
  loaderDeps: ({ search }) => search,
  beforeLoad: requireRoute('/installer/jobs'),
  loader: async ({ context, deps }) => {
    const { jobHistoryScreen } = await import('@/ui/pages/Installer/JobHistory/jobHistoryScreen');
    return jobHistoryScreen.loaderFor()({ context, deps });
  },
  component: JobHistoryPage,
});
